<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<div class="part">
<p class="noindent_paraf"><span epub:type="pagebreak" id="page_12" title="12">Railroads are immensely complex, and they seem to love complexity, just as they love ritual and the past.</span></p>
<p class="rightr">E. B. White, “Progress and Change”</p>
<p class="common"><img alt="" src="images/common.jpg" style="width: 15%"/></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter07.vue?f36b20ac